import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "./store/index";
import connection from "@/utils/connection";
/* ========== BOOTSTRAP ========== */
import "./bootstrap.js";

import "./filters/Humanize";
import "./directives/OuterClick";

/* ========== MIXINS ========== */
import GlobalMixins from "@/mixins/Global";
Vue.mixin(GlobalMixins);

/* ========== GLOBAL COMPONENTS ========== */
import PageContainer from "@/components/PageContainer";
Vue.component("page-container", PageContainer);

Vue.config.productionTip = false;
Vue.config.devtools = false;

var app = new Vue({
	router,
	store,
	render: h => h(App),
	data: {
		isOnline: window.navigator.onLine
	}
}).$mount("#app");

window.addEventListener("online", () => { connection.updateConnectionStatus(app); });
window.addEventListener("offline", () => { connection.updateConnectionStatus(app); });
